// import React from 'react';
import axios from 'axios';

const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/imagenes';

const imagenesApi = {

    listado: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`, {
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        // Validar retorno de array
        return Array.isArray(response.data) ? response.data[0] : response.data;
    } catch (error) {
        console.error('Error fetching activos:', error);
        return [];
    }
},

    baja: async ( id : string ) => {
        try {
            const response = await axios.get(`${BASE_URL}/baja/${id}`, {
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        // Validar retorno de array
        return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching informacion de baja de estado:', error);
            return [];
        }
    }
};

export default imagenesApi;